import React, { Component } from 'react';
import logo from './logo.svg';
import './NotFound.css';
import RaisedButton from 'material-ui/RaisedButton';


class NotFound extends Component {
  render() {
    return (
      <div>
        <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>NotFound</h2>
        </div>
        <p className="App-intro">
          path not found
        </p>
        <RaisedButton label="Primary" primary={true} style={{margin: 12}} />
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/common/NotFound.js